import { Table } from './Table';
import { HighestCampaignsTableSkeleton } from './HighestCampaignsTableSkeleton';
import { HighestConversionCampaign } from '../../../../types';

type HighestCampaignsProps = {
  values: HighestConversionCampaign[];
  isLoading?: boolean;
};

export const HighestCampaignsTable = ({ values, isLoading }: HighestCampaignsProps) =>
  isLoading ? <HighestCampaignsTableSkeleton /> : <Table values={values} />;
